/* eslint-disable react/no-danger */
import React from 'react';

class RenderHTML extends React.Component {
  static defaultProps = {
    html: ''
  };

  static propTypes = {
    html: React.PropTypes.string.isRequired
  };

  render() {
    return <span dangerouslySetInnerHTML={{ __html: this.props.html }} />;
  }
}

export default RenderHTML;



// WEBPACK FOOTER //
// ./src/js/components/RenderHTML.js